import HomeLink from "../HomeLink";
import NavigationLink from "../NavigationLink";

const DesktopNavigationMenu = ({ sections, selectedIndex, onItemClick }) => {
  return (
    <nav className="hidden flex-col gap-6 text-lg font-medium md:w-full md:flex md:flex-row md:items-center md:gap-5 md:text-sm lg:gap-6">
      <HomeLink />
      {sections?.map((item, index) => (
        <NavigationLink
          key={`navbar_item_${item.code}`}
          item={item}
          index={index}
          isSelected={selectedIndex === index}
          onItemClick={onItemClick}
        />
      ))}
    </nav>
  );
};

export default DesktopNavigationMenu;
